import { Skeleton } from '@/components/ui';

/**
 * Layout-mirroring skeleton for the FTUE lobby slot — shown while the
 * experiment assignment resolves (LaunchDarkly init) and while the
 * make-a-call arm loads its data. Mirrors the shared silhouette of both
 * arms (hero-height block, wide snake strip, card row) so neither variant
 * reflows when it lands.
 */
export function FtueLobbySkeleton() {
  return (
    <div className="w-full px-3.5 md:px-0 md:max-w-[760px] xl:max-w-[1300px] mx-auto flex flex-col gap-4 md:gap-5 pb-6">
      <div className="flex w-full flex-col gap-2.5 md:max-w-[760px] md:mx-auto">
        <Skeleton className="h-6 w-52 rounded-md" />
        <Skeleton className="h-[180px] w-full rounded-xl" />
      </div>
      <Skeleton className="h-[120px] w-full rounded-xl" />
      <div className="flex flex-col gap-2.5 md:grid md:grid-cols-2 md:gap-4 xl:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-[180px] w-full rounded-xl" />
        ))}
      </div>
    </div>
  );
}
